/*
 * Przeciąganie karuzel myszą — globalnie, dla każdego `.slider` w motywie
 * (wpięte w layout/theme.liquid).
 *
 * DWIE KLASY, nie jedna:
 *
 *   `karuzela--chwyt`   — od wciśnięcia przycisku myszy. Kursor „łapki",
 *                         `user-select: none` i wyjątek od `scroll-behavior:
 *                         smooth !important` (custom-produkt.css), żeby kadr
 *                         szedł 1:1 za kursorem.
 *   `karuzela--ciagnie` — dopiero po przekroczeniu progu PROG, czyli gdy to
 *                         NA PEWNO przeciąganie, a nie klik. Dopiero ta klasa
 *                         gasi `pointer-events` na linkach i obrazkach
 *                         (custom-sekcje.css).
 *
 * Rozdzielenie jest krytyczne: gdy `pointer-events: none` schodziło na linki
 * już przy `pointerdown`, `pointerup` trafiał w inny element niż `pointerdown`,
 * więc przeglądarka wystawiała `click` na wspólnym rodzicu — i KART W KARUZELI
 * NIE DAŁO SIĘ KLIKNĄĆ w ogóle (2026-09-08, „Zobacz też" na karcie produktu).
 */
(function () {
  'use strict';

  var PROG = 5; // px — ruch poniżej progu to klik, nie przeciąganie

  function podepnij(slider) {
    if (slider.dataset.dragBound === '1') return;
    slider.dataset.dragBound = '1';

    var ciagnie = false;
    var przeciagnieto = false;
    var zjedzKlik = false;
    var startX = 0;
    var startScroll = 0;

    slider.addEventListener('pointerdown', function (e) {
      // Dotyk ma własne, natywne przewijanie — nie wchodzimy mu w drogę
      if (e.pointerType === 'touch') return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      ciagnie = true;
      przeciagnieto = false;
      // Świeży gest kasuje ewentualną zaległą blokadę kliku z poprzedniego
      zjedzKlik = false;
      startX = e.clientX;
      startScroll = slider.scrollLeft;
      slider.style.scrollBehavior = 'auto';
      slider.classList.add('karuzela--chwyt');
    });

    slider.addEventListener('pointermove', function (e) {
      if (!ciagnie) return;

      var delta = e.clientX - startX;

      if (!przeciagnieto && Math.abs(delta) > PROG) {
        przeciagnieto = true;
        slider.classList.add('karuzela--ciagnie');
        try {
          slider.setPointerCapture(e.pointerId);
        } catch (err) {}
      }

      if (przeciagnieto) {
        e.preventDefault();
        slider.scrollLeft = startScroll - delta;
      }
    });

    function koniec(e) {
      if (!ciagnie) return;

      ciagnie = false;
      slider.classList.remove('karuzela--chwyt');
      slider.classList.remove('karuzela--ciagnie');
      slider.style.scrollBehavior = '';

      try {
        slider.releasePointerCapture(e.pointerId);
      } catch (err) {}

      // Po przeciągnięciu klik, który zaraz przyjdzie, ma NIE otworzyć produktu
      zjedzKlik = przeciagnieto;
    }

    slider.addEventListener('pointerup', koniec);
    slider.addEventListener('pointercancel', koniec);
    slider.addEventListener('pointerleave', koniec);

    /*
     * Zjadacz kliku jest STAŁY i sterowany flagą. Wcześniej dopinał się dopiero
     * po przeciągnięciu i zdejmował sam siebie w pierwszym kliku — a gdy gest
     * kończył się poza karuzelą, żaden klik do slidera nie docierał i zjadacz
     * zostawał na kolejny, prawdziwy klik w kartę.
     */
    slider.addEventListener(
      'click',
      function (ev) {
        if (!zjedzKlik) return;
        zjedzKlik = false;
        ev.preventDefault();
        ev.stopPropagation();
      },
      true
    );

    // Natywne przeciąganie obrazka/linku psuje gest od pierwszych pikseli,
    // więc blokujemy je przez cały czas trzymania przycisku
    slider.addEventListener('dragstart', function (e) {
      if (ciagnie) e.preventDefault();
    });
  }

  function skanuj() {
    document.querySelectorAll('.slider, ul.slider__grid, .slider--desktop').forEach(podepnij);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', skanuj);
  } else {
    skanuj();
  }
  document.addEventListener('shopify:section:load', skanuj);
})();
